<template>
    <div class="opui-item op-flow-type-trigger">
        <div class="opui-left" @click.prevent="$emit('edit', item)">
            <a class="op-flow-icon" href="#">
                <span v-html="item.icon"></span>
            </a>
            <div class="opui-title">
                <h3><a href="#">{{ $e('Only if') }}</a></h3>

                <div class="opfl-filter-row-description"
                     v-if="item.row_descriptions && item.row_descriptions.length"
                     v-for="description in item.row_descriptions"
                >
                    <span class="opfl-filter-row-field">{{ description.field }}</span>
                    <span class="opfl-filter-row-operator">{{ description.operator }}</span>
                    <span class="opfl-filter-row-value" v-if="description.value">{{ description.value }}</span>
                </div>
            </div>
        </div>
        <div class="op-flow-actions">
            <a href="#" @click.prevent="$emit('delete', item)" class="op-flow-action">
                <i class="opui-icon-trash"></i>
                {{ $e('Delete') }}
            </a>
            <a href="#" @click.prevent="$emit('edit', item)" class="op-flow-action">
                <i class="opui-fa opui-fa-cog"></i>
                {{ $e('Edit') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
}
</script>

<style scoped>
.opfl-filter-row-description {
    margin: 6px 0;
    font-size: 12px;
    color: #666;
}

.opfl-filter-row-description:first-child {
    margin-top: 10px;
}

.opfl-filter-row-field {
    display: inline-block;
}

.opfl-filter-row-operator {
    display: inline-block;
    margin: 0 0 0 5px;
}

.opfl-filter-row-value {
    display: inline-block;
    margin: 0 0 0 5px;
    background: #eee;
    border-radius: 3px;
    padding: 2px 5px;
}
</style>
